import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
export function matchPasswordValidator(passwordControlName: string, confirmPasswordControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get(passwordControlName)?.value;
    const confirmPassword = formGroup.get(confirmPasswordControlName)?.value;

    return password === confirmPassword ? null : { passwordsMismatch: true };
  };
}